var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
import { createAssociatedTokenAccountIdempotentInstruction, } from "@solana/spl-token";
import { Connection, PublicKey } from "@solana/web3.js";
import { SOLANA_SPL_ATA_PROGRAM_ID, } from "../utils/const";
import { delay } from "./delay";
import { standardToProgram, whichStandard } from "./findNftDataAndAccounts.function";
export function findOrCreateAta(Data) {
    return __awaiter(this, void 0, void 0, function () {
        var tokenStandard, tokenProg, values, mintAtas, mintAta_1, mintAta, _a, mintAtas_1, mintAtas_1_1, ata, balance, e_1_1, eee_1, mintAta;
        var _b, e_1, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    if (!!Data.clusterOrUrl && !!Data.connection) {
                    }
                    else if (!!Data.clusterOrUrl) {
                        Data.connection = new Connection(Data.clusterOrUrl);
                    }
                    else if (!!Data.connection) {
                        Data.clusterOrUrl = Data.connection.rpcEndpoint;
                    }
                    else
                        throw "there should be a Program or a Cluster";
                    return [4 /*yield*/, whichStandard({ connection: Data.connection, mint: Data.mint })];
                case 1:
                    tokenStandard = _e.sent();
                    tokenProg = standardToProgram(tokenStandard);
                    _e.label = 2;
                case 2:
                    _e.trys.push([2, 19, , 20]);
                    values = [];
                    return [4 /*yield*/, Data.connection.getParsedTokenAccountsByOwner(new PublicKey(Data.owner), {
                            mint: new PublicKey(Data.mint),
                            programId: new PublicKey(tokenProg),
                        })];
                case 3:
                    mintAtas = (_e.sent()).value;
                    // console.log("mintAtas", mintAtas);
                    if (mintAtas.length === 0) {
                        mintAta_1 = PublicKey.findProgramAddressSync([
                            new PublicKey(Data.owner).toBuffer(),
                            new PublicKey(tokenProg).toBuffer(),
                            new PublicKey(Data.mint).toBuffer(),
                        ], new PublicKey(SOLANA_SPL_ATA_PROGRAM_ID))[0].toString();
                        console.log("no ata found, creating ", mintAta_1, " from ", Data.owner, "mint", Data.mint, tokenStandard);
                        return [2 /*return*/, {
                                mintAta: mintAta_1,
                                instruction: createAssociatedTokenAccountIdempotentInstruction(new PublicKey(Data.signer), new PublicKey(mintAta_1), new PublicKey(Data.owner), new PublicKey(Data.mint), new PublicKey(tokenProg)),
                            }];
                    }
                    mintAta = mintAtas[0].pubkey.toString();
                    if (!(mintAtas.length > 1)) return [3 /*break*/, 18];
                    console.log("more than 1 ata", mintAtas);
                    _e.label = 4;
                case 4:
                    _e.trys.push([4, 11, 12, 17]);
                    _a = true, mintAtas_1 = __asyncValues(mintAtas);
                    _e.label = 5;
                case 5: return [4 /*yield*/, mintAtas_1.next()];
                case 6:
                    if (!(mintAtas_1_1 = _e.sent(), _b = mintAtas_1_1.done, !_b)) return [3 /*break*/, 10];
                    _d = mintAtas_1_1.value;
                    _a = false;
                    ata = _d;
                    return [4 /*yield*/, Data.connection.getTokenAccountBalance(ata.pubkey)];
                case 7:
                    balance = _e.sent();
                    return [4 /*yield*/, delay(300)];
                case 8:
                    _e.sent();
                    if (balance.value.uiAmount || balance.value.uiAmount === 0)
                        values.push({ value: balance.value.uiAmount, address: ata.pubkey });
                    _e.label = 9;
                case 9:
                    _a = true;
                    return [3 /*break*/, 5];
                case 10: return [3 /*break*/, 17];
                case 11:
                    e_1_1 = _e.sent();
                    e_1 = { error: e_1_1 };
                    return [3 /*break*/, 17];
                case 12:
                    _e.trys.push([12, , 15, 16]);
                    if (!(!_a && !_b && (_c = mintAtas_1.return))) return [3 /*break*/, 14];
                    return [4 /*yield*/, _c.call(mintAtas_1)];
                case 13:
                    _e.sent();
                    _e.label = 14;
                case 14: return [3 /*break*/, 16];
                case 15:
                    if (e_1) throw e_1.error;
                    return [7 /*endfinally*/];
                case 16: return [7 /*endfinally*/];
                case 17:
                    values.sort(function (a, b) { return b.value - a.value; });
                    mintAta = values[0].address.toString();
                    _e.label = 18;
                case 18: 
                // console.log(tokenStandard, mintAta, Data.owner);
                return [2 /*return*/, {
                        mintAta: mintAta,
                    }];
                case 19:
                    eee_1 = _e.sent();
                    mintAta = PublicKey.findProgramAddressSync([
                        new PublicKey(Data.owner).toBuffer(),
                        new PublicKey(tokenProg).toBuffer(),
                        new PublicKey(Data.mint).toBuffer(),
                    ], new PublicKey(SOLANA_SPL_ATA_PROGRAM_ID))[0].toString();
                    console.log("no ata found, creating ", mintAta, " from ", Data.owner, "mint", Data.mint);
                    return [2 /*return*/, {
                            mintAta: mintAta,
                            instruction: createAssociatedTokenAccountIdempotentInstruction(new PublicKey(Data.signer), new PublicKey(mintAta), new PublicKey(Data.owner), new PublicKey(Data.mint), new PublicKey(tokenProg)),
                        }];
                case 20: return [2 /*return*/];
            }
        });
    });
}
